module.exports = __webpack_public_path__ + "static/img/event5.153dfe2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event5.png
// module id = KKVJ
// module chunks = 1